import dayjs from "dayjs"
import { cache } from "react"

import http from "../../../../utils"
import { AnnouncementListResponse } from "./interface"

/**
 * 服务端获取公告列表
 * @returns 公告列表响应
 */
export const getAnnouncementsServer = cache(async () => {
  try {
    return await http.get<
      {
        startTime: number
        endTime: number
      },
      AnnouncementListResponse
    >(`/newscenter/new_en/announce/list`, {
      params: {
        startTime: dayjs().subtract(3, "day").startOf("day").unix(),
        endTime: dayjs().endOf("day").unix(),
      },
      successCode: 100000,
      // 使用 Next.js 缓存确保请求去重，避免重复请求
      // 公告信息可以缓存较长时间，因为时间参数已经限制了范围
      next: { revalidate: 60, tags: ["header-announcements"] },
    })
  } catch (error) {
    console.error("Failed to fetch announcements:", error)
    return null
  }
})
